export default __webpack_public_path__ + "static/media/smallRightArrow.7ce8a1ba.svg";